<template>
  <a-drawer width="50%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-row :gutter="12">
        <a-col :span="24">
          <a-form-model-item label="公司名称" prop="companyId" >
            <a-select v-model="form.companyId" placeholder="请选择">
              <a-select-option v-for="(company,index) in companyList" :key="index" :value="company.id">{{ company.companyName }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="24">
          <a-form-model-item label="岗位名称" prop="name" >
            <a-input v-model="form.name" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="24">
          <a-form-model-item label="岗位专区分类" prop="precinctId" >
            <a-select v-model="form.precinctId" placeholder="请选择">
              <a-select-option v-for="(precinct,index) in precinctList" :key="index" :value="precinct.id">{{ precinct.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="24">
          <a-form-model-item label="工种类别" prop="workId" >
            <a-select v-model="form.workId" placeholder="请选择">
              <a-select-option v-for="(work,index) in workList" :key="index" :value="work.id">{{ work.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="平台类型" prop="platformType" >
            <a-select v-model="form.platformType" mode="multiple" placeholder="请选择">
              <a-select-option :value="'1'">微信</a-select-option>
              <a-select-option :value="'2'">抖音</a-select-option>
              <a-select-option :value="'3'">支付宝</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="是否为人气工作专区" prop="isHot" >
            <a-radio-group v-model="form.isHot">
              <a-radio :value="false">否</a-radio>
              <a-radio :value="true">是</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="职位工资" prop="wageType" >
            <a-radio-group v-model="form.wageType" >
              <a-radio :value="1">综合工资</a-radio>
              <a-radio :value="2">固定工资</a-radio>
              <a-radio :value="3">自定义工资</a-radio>
            </a-radio-group>
            <div v-if="form.wageType === 1">
              <a-col :span="8">
                <a-input type="number" :step="0.01" v-model="form.minWage" placeholder="请输入" addon-after="元"/>
              </a-col>
              <a-col :span="1">
                至
              </a-col>
              <a-col :span="8">
                <a-input type="number" :step="0.01" v-model="form.maxWage" placeholder="请输入" addon-after="元"/>
              </a-col>
            </div>
            <div v-if="form.wageType === 2">
              <a-col :span="16">
                <a-input type="number" :step="0.01" v-model="form.minWage" placeholder="请输入固定工资" addon-after="元"/>
              </a-col>
            </div>
            <div v-if="form.wageType === 3">
              <a-col :span="16">
                <a-input v-model="form.minWage" placeholder="请输入职位工资信息"/>
              </a-col>
            </div>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="结算方式" prop="clearingForm" >
            <a-radio-group v-model="form.clearingForm">
              <a-radio :value="1">小时结</a-radio>
              <a-radio :value="2">日结</a-radio>
              <a-radio :value="3">周结</a-radio>
              <a-radio :value="4">月结</a-radio>
              <a-radio :value="5">项目结</a-radio>
              <a-radio :value="6">按件结</a-radio>
              <a-radio :value="7">面议</a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="预计佣金" prop="commission" >
            <a-input type="number" :min="0" :step="1" v-model="form.commission" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="招聘信息失效时间" prop="expiryDate" >
            <a-date-picker
              style="width: 100%"
              v-model="form.expiryDate"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              show-time
              allow-clear/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="最小年龄" prop="minAge" >
            <a-select v-model="form.minAge" placeholder="请选择">
              <a-select-option :value="'不限'">不限</a-select-option>
              <a-select-option v-for="(index) in ageNumber" :key="index" :value="index">{{ index }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="最大年龄" prop="maxAge" >
            <a-select v-model="form.maxAge" placeholder="请选择">
              <a-select-option :value="'不限'">不限</a-select-option>
              <a-select-option v-for="(index) in ageNumber" :key="index" :value="index">{{ index }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="性别" prop="sex" >
            <a-select v-model="form.sex" placeholder="请选择">
              <a-select-option :value="'不限'">不限</a-select-option>
              <a-select-option :value="'男'">男</a-select-option>
              <a-select-option :value="'女'">女</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="招聘人数" prop="recruitNum" >
            <a-select v-model="form.recruitNum" placeholder="请选择">
              <a-select-option :value="'不限'">不限</a-select-option>
              <a-select-option v-for="(index) in recruitNumber" :key="index" :value="index">{{ index }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="10">
          <a-form-model-item label="学历" prop="education" >
            <a-select v-model="form.education" placeholder="请选择">
              <a-select-option :value="1">大专</a-select-option>
              <a-select-option :value="2">本科</a-select-option>
              <a-select-option :value="3">硕士</a-select-option>
              <a-select-option :value="4">博士</a-select-option>
              <a-select-option :value="5">不要求</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="10">
          <a-form-model-item label="工作经验" prop="workExperience" >
            <a-select v-model="form.workExperience" placeholder="请选择">
              <a-select-option :value="1">应届毕业生</a-select-option>
              <a-select-option :value="2">3年及以下</a-select-option>
              <a-select-option :value="3">3-5年</a-select-option>
              <a-select-option :value="4">5-10年</a-select-option>
              <a-select-option :value="5">10年以上</a-select-option>
              <a-select-option :value="6">经验不限</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="24">
          <a-form-model-item label="岗位收费说明" prop="explain" >
            <a-textarea :row="4" v-model="form.explain" placeholder="请输入" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="24">
          <a-form-model-item label="标签" prop="tagIds" >
            <a-select v-model="tagIds" mode="multiple" style="width: 100%" placeholder="请选择">
              <a-select-option v-for="(tag,index) in tagList" :key="index" :value="tag.id">
                {{ tag.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="24">
          <a-form-model-item label="职位描述" prop="description" >
            <editor :editorValue="'editor'" v-model="form.description"></editor>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="12">
        <a-col :span="24">
          <a-form-model-item label="排序" prop="sort" >
            <a-button-group>
              <a-button @click="decline">
                <template><a-icon type="minus" /></template>
              </a-button>
              <a-input @input="validateNumber" type="number" :max-length="5" style="width: 120px" v-model="form.sort"/>
              <a-button @click="increase">
                <template><a-icon type="plus" /></template>
              </a-button>
            </a-button-group>
          </a-form-model-item>
        </a-col>
      </a-row>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCompany, addCompany, updateCompany } from '@/api/user/companyPost'
import { listTag } from '@/api/user/tag'
import { listCompany } from '@/api/user/company'
import Editor from '@/components/Editor'
import { listPrecinct } from '@/api/user/precinct'
import { listWork } from '@/api/user/work'
export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      ageNumber: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100],
      recruitNumber: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293, 294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332, 333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365, 366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378, 379, 380, 381, 382, 383, 384, 385, 386, 387, 388, 389, 390, 391, 392, 393, 394, 395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 406, 407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 418, 419, 420, 421, 422, 423, 424, 425, 426, 427, 428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, 440, 441, 442, 443, 444, 445, 446, 447, 448, 449, 450, 451, 452, 453, 454, 455, 456, 457, 458, 459, 460, 461, 462, 463, 464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474, 475, 476, 477, 478, 479, 480, 481, 482, 483, 484, 485, 486, 487, 488, 489, 490, 491, 492, 493, 494, 495, 496, 497, 498, 499, 500],
      tagIds: [],
      tagList: [],
      companyList: [],
      precinctList: [],
      workList: [],
      // 表单参数
      form: {
        id: null,
        companyId: null,
        name: null,
        precinctId: null,
        workId: null,
        isHot: true,
        wageType: 1,
        minWage: null,
        maxWage: null,
        clearingForm: 4,
        commission: null,
        expiryDate: null,
        minAge: null,
        maxAge: null,
        sex: null,
        platformType: null,
        recruitNum: null,
        education: null,
        workExperience: null,
        explain: null,
        tagIds: null,
        description: null,
        sort: null,
        cateName: null,
        createTime: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        platformType: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        description: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        tagIds: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        explain: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        workExperience: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        education: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        recruitNum: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        maxAge: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        precinctId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        workId: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        isHot: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        wageType: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        minWage: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        maxWage: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        clearingForm: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        commission: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        expiryDate: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        minAge: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    queryWorkList() {
      const param = { status: 1 }
      listWork(param).then(response => {
        this.workList = response.data
      })
    },
    queryPrecinctList() {
      const param = { status: 1 }
      listPrecinct(param).then(response => {
        this.precinctList = response.data
      })
    },
    queryCompanyList() {
      const param = { status: 1 }
      listCompany(param).then(response => {
        this.companyList = response.data
      })
    },
    validateNumber(event) {
      // 允许输入数字、小数点、负号
      // 同时设置了type="number"，所以还能防止非数字的输入
      event.target.value = event.target.value.replace(/[^0-9.]+/g, '')
      // 如果有小数点，只保留第一个
      const decimalIndex = event.target.value.indexOf('.')
      if (decimalIndex !== -1) {
        event.target.value = event.target.value.substr(0, decimalIndex) + '.' + event.target.value.substr(decimalIndex).replace(/\./g, '')
      }
      // 如果第一个字符是负号，保证只有当输入有数字时才允许负号
      if (event.target.value[0] === '-' && event.target.value.length > 1) {
        event.target.value = '-' + event.target.value.substr(1).replace(/[^0-9.]+/g, '')
      }
      // 更新数据
      this.form.sort = parseFloat(event.target.value)
    },
    decline() {
      const that = this
      that.form.sort = that.form.sort - 1
      if (that.form.sort < 0) {
        that.form.sort = 0
      }
    },
    increase() {
      const that = this
      that.form.sort = that.form.sort + 1
    },
    queryTagList() {
      const param = { type: 1 }
      listTag(param).then(response => {
        this.tagList = response.data
      })
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.companyList = []
      this.precinctList = []
      this.workList = []
      this.tagIds = []
      this.tagList = []
      this.formType = 1
      this.form = {
        id: null,
        platformType: null,
        companyId: null,
        name: null,
        precinctId: null,
        workId: null,
        isHot: true,
        wageType: 1,
        minWage: null,
        maxWage: null,
        clearingForm: 4,
        commission: null,
        expiryDate: null,
        minAge: null,
        maxAge: null,
        sex: null,
        recruitNum: null,
        explain: null,
        tagIds: null,
        description: null,
        sort: null,
        cateName: null,
        createTime: null,
        remark: null
      }
      // this.$nextTick(() => {
      //   if (this.$refs.form) {
      //     this.$refs.form.resetFields()
      //   }
      // })
      this.queryTagList()
      this.queryCompanyList()
      this.queryPrecinctList()
      this.queryWorkList()
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '岗位新增'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCompany({ 'id': id }).then(response => {
        this.form = response.data
        if (this.form.tagIds) {
          this.tagIds = this.form.tagIds.split(',')
        }
        if (this.form.platformType) {
          this.form.platformType = this.form.platformType.split(',')
        }
        this.open = true
        this.formTitle = '查看/编辑岗位'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.form.tagIds = this.tagIds.join(',')
      this.form.platformType = this.form.platformType.join(',')
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCompany(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCompany(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
